<script setup>
import AppNavbar from '@/components/AppNavbar.vue'
import Notifications from '@/components/Notifications.vue'
import router from '@/router/router'
import AppFooterAdmin from '@/components/AppFooterAdmin.vue'
</script>

<template>
  <Notifications />
  <div class="d-flex flex-column min-vh-100">
    <AppNavbar />

    <main class="flex-grow-1" style="margin-top: 59px;">
      <div class="container">
        <router-view v-slot="{ Component }">
          <component :is="Component" :key="router.currentRoute.value.path" />
        </router-view>
      </div>
    </main>
  </div>

  <AppFooterAdmin />
</template>

<style scoped>
/* Если потребуется другая высота шапки — поменяйте margin-top */
</style>